import { BaseDynamicZoneModel } from "@models/dynamic-zones";
import { ImageDataLike } from "gatsby-plugin-image";
import { ColorFormat } from "react-countdown-circle-timer";

export enum TimedFeatureListVariant {
  LINEAR = "linear",
  CIRCULAR = "circular",
}

export enum TimedFeatureImagePostion {
  LEFT = "left",
  RIGHT = "right",
}

export interface OneTimedFeatureModel {
  id: string;
  featureImage: {
    localFile: (ImageDataLike & { url: string; ext: string }) | null;
  };
  featureSubTitle: string;
  featureTitle: string;
  order: number;
  featureIcon: string;
  featureHeader?: string;
  featureDescription?: string;
  ctaText?: string;
  ctaLink?: string;
}

export interface TimedFeatureModel {
  timedFeatures?: OneTimedFeatureModel[];
  times: number;
  learnMoreLink: string;
  learnMoreText: string;
  color: string;
  progressEmptyColor: ColorFormat;
  progressFillColor: ColorFormat;
  bgColor: string;
  variant: TimedFeatureListVariant;
  imgPosition?: TimedFeatureImagePostion;
}
export type TimedFeatureDynamicZoneModel = BaseDynamicZoneModel &
  TimedFeatureModel;
export interface TimedFeatureListPropsModel {
  componentData: TimedFeatureDynamicZoneModel;
}
